import nestAxios from 'services/_nestAxios'
import contaAxios from 'services/_contaAxios'

const getData = ({ useConta }, { url, params }) => {
  if (useConta) {
    return contaAxios.get(url, { params })
  }

  return nestAxios.get(url, { params })
}

const objetoSalida = {
  getData
}

export default objetoSalida
